<template>
  <div class="banner-container">
    <img
      src="/images/o0I3t65.jpg"
      alt="bigbanner-background"
      class="banner-img"
    />
    <h1 class="banner-img__header text-center">
      Your Global Access Enabler in 190+ Countries
    </h1>
  </div>
</template>

<script>
export default {
  name: 'BigBanner',
};
</script>

<style scoped>
.banner-container {
  position: relative;
  width: 100%;
  height: auto;
}

.banner-img {
  width: 100%;
  height: auto;
  margin-top: -64px;
}

.banner-img__header {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* This will center the heading horizontally and vertically */
  line-height: 1.5;
  font-size: 4rem;
  font-weight: 1000;
  color: rgb(255, 255, 255);
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.text-center {
  text-align: center;
}

@media (max-width: 768px) {
  .banner-img__header {
    font-size: 2.5rem; /* Adjust font size for tablets */
  }
}

@media (max-width: 480px) {
  .banner-img__header {
    font-size: 2rem; /* Adjust font size for mobile */
  }
}
</style>
